// ** Custom Componens
import SectionCards from "../../SectionCards"
import SectionColumnText from "../../SectionColumnText"
import SectionColumnVideo from "../../SectionColumnVideo"
import SectionAccordion from "../../SectionAccordion"
import SectionRates from "../../SectionRates"
import SectionTimeline from "../../SectionTimeline"
import SectionFeaturedProfile from "../../SectionFeaturedProfile"
import SectionSupport from "../../SectionSupport"
import SectionFaq from "../../SectionFaq"
import SectionCalculator from "../../SectionCalculator"
import SectionAffordabilityCalculator from "../../SectionAffordabilityCalculator"
import SectionHomepageHero from "../../SectionHomepageHero"
import SectionFeaturedOn from "../../SectionFeaturedOn"
import SectionCTA from "../../SectionCTA"
import SectionButtonAction from "../../SectionButtonAction"
import SectionColumnPoints from "../../SectionColumnPoints"
import SectionTwoCol from "../SectionTwoCol"
import SectionLenderLogo from "../SectionLenderLogo"

const SectionList = ({ section }: any) => {
  const { listType, tags, title } = section

  if (listType === "default") {
    if (tags.includes("section-faq") || tags.includes("section-job-list")) {
      return <SectionAccordion section={section} />
    } else if (tags.includes("section-blog-faq")) {
      return <SectionFaq section={section} />
    } else if (tags.includes("section-lender-logos")) {
      return <SectionLenderLogo section={section} />
    } else if (tags.includes("section-column-video")) {
      return <SectionColumnVideo section={section} />
    } else if (tags.includes("section-featured-profile")) {
      return <SectionFeaturedProfile section={section} />
    } else if (tags.includes("section-support")) {
      return <SectionSupport section={section} />
    } else if (title?.includes('Mortgage Payment Calculator')) {
      return <SectionCalculator section={section} />;
    } else if (title?.includes('Mortgage Affordability Calculator')) {
      return <SectionAffordabilityCalculator section={section} />;
    }
    else if (tags.includes("section-homepage-hero")) {
      return <SectionHomepageHero section={section} />
    } else if (tags.includes("section-featured-on")) {
      return <SectionFeaturedOn section={section} />
    } else if (tags.includes("section-cta-2")) {
      return <SectionCTA section={section} />
    } else if (tags.includes("section-button-action")) {
      return <SectionButtonAction section={section} />
    } else if (tags.includes("section-two-co")) {
      return <SectionTwoCol section={section} />
    }
    return <SectionColumnText section={section} />
  } else if (listType === "timeline") {
    return <SectionTimeline section={section} />
  } else if (listType === "cards") {
    return <SectionCards section={section} />
  } else if (listType === "rates") {
    return <SectionRates section={section} />
  } else if (listType === "points") {
    return <SectionColumnPoints section={section} />
  }
  return null
}

export default SectionList
